<div class="footer-area text-center bg-white border-top-radius box-shadow"
    [class.card-borderd-theme]="themeService.isCardBorder()" [class.component-dark-theme]="themeService.isDark()"
    [class.card-border-radius]="themeService.isCardBorderRadius()">
    <!-- <p>Copyright © 2025 <a href="https://www.odedtech.com/" class="fw-semibold" target="_blank">Oded</a></p> -->
    <p>Powered by <a href="https://www.odedtech.com/" class="fw-semibold" target="_blank">Oded</a></p>

</div>